// extracted by mini-css-extract-plugin
export default {"search_input":"style_search_input__PkUQW","search_btn":"style_search_btn__B3gCs"};